import { Box, InputLabel, styled } from '@mui/material';

const ChipBox = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  mr: 1
});

const MultiInputWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  overflowY: 'hidden',
  alignItems: 'center',
  height: '52px',
  width: '100%',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,

  '&:hover': {
    borderColor: theme.palette.text.primary
  },
  '&:focus-within': {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 1px ${theme.palette.primary.main}`
  }
}));

const MultiInputLabel = styled(InputLabel)({
  margin: 0,
  color: '#101828 !important',
  fontSize: 13,
  fontWeight: 500,
  marginBottom: '6px',
  overflow: 'auto',
  position: 'static',
  transform: 'none'
});

export { ChipBox, MultiInputWrapper, MultiInputLabel };
